export type Point = {
  readonly x: number;
  readonly y: number;
};

export type CoordinatePair = {
  readonly p1: Point;
  readonly p2: Point;
};

export type LockRange = {
  readonly min: number;
  readonly max: number;
};

export const DEFAULT_LOCK_RANGE: LockRange = {
  min: 400,
  max: 1000,
};
